import { catchError, first, map, of } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';

export const activateCompanyGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const companyId = route.paramMap.get('id');
  const authService = inject(AuthService);
  const userId = authService.user$.getValue()?.data?.id;
  const currentUser = authService.user$.getValue()?.data;

  if (companyId && userId) {
    const permissionService = inject(PermissionService);
    permissionService.setActiveCompany(companyId, userId);
  }

  if (companyId && authService.isSuperAdmin(currentUser)) {
    if (currentUser?.supportCompanyId === companyId) {
      return of(true);
    }
  }

  return authService.generateJwtToken(companyId).pipe(
    first(),
    map(() => true),
    catchError((error: unknown) => {
      console.error(error instanceof Error ? error.message : String(error));

      return of(false);
    }),
  );
};
